import { Component, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/httpService';



declare var cabbage: any;


@Component({
  selector: 'app-white-label-demo',
  templateUrl: './white-label-demo.component.html',
})
export class WhiteLabelDemoComponent {





  source;
  connector;
  public_token = "";


  color = "";
  logo = "";
  name = "";
  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {


    this.source = decodeURI(this.activeRoute.snapshot.params['id']);


    //this.source = 'x37hcmk2';
    //this.connector = 'link_production_wj0ut69zz8t1oz0bko3aoqmu';
    //this.fetchVendor();



    const request = {
      SessionIdentifier: this.source
    }


    this.connector = this.source;

    this.httpService.post<any>('Store/get-link-token-white-label', request, false).subscribe(
      resp => {

        console.log(JSON.parse(resp.message));

        //console.log(resp);
        if (JSON.parse(resp.message).response != "expired") {

          this.result = JSON.parse(resp.message);


          this.color = this.result.result.themeColor;
          this.logo = this.result.result.themeLogo;
          this.name = this.result.result.clientName;
          //this.loading = false;
        }
        else {

          this.public_token = "Completed";
        }

      },
      error => {


        //this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });









    this.fetchLink();

    //cabbage.initializeLink(this.source);
    //initializaConnectPayLink(this.connector);
  }


























  //show() {
  //  cabbage.displayPayLink(this.source);
  //}


  connect() {
    cabbage.initializeGrid(this.connector);

    cabbage.openGrid(this.connector);
  }


  result;

  fetchLink() {


          cabbage.initializeGrid(this.connector);

    //cabbage.openGrid(this.connector);



      
  }







  @HostListener('window:message', ['$event'])
  onMessage(event) {


    //console.log(event)

    //if (event.origin == "https://cdn-sandbox.cabbagepay.com") {

      const data = JSON.parse(event.data);
      //console.log(data.message)

      if (data.message == "success") {

        this.public_token = data.public_token;
        cabbage.closeGrid();
        console.log(data.public_token)

      }



      if (data.message == "terminated") {
        console.log("termination")
        cabbage.closeGrid();


      }


    



    //cabbage.closeLink();



  };

}
